import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Practitioners cannot edit appointments. Redirect to the read-only view.
 * Admin / super-admin edit via /appointments/:id.
 */
export function PractitionerAppointmentEditPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      navigate(`/practitioner/appointments/${id}`, { replace: true });
    } else {
      navigate('/practitioner/appointments', { replace: true });
    }
  }, [id, navigate]);

  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      <span className="ml-2 text-gray-600">Redirection...</span>
    </div>
  );
}

export default PractitionerAppointmentEditPage;
